'use client';

import { useState } from 'react';
import { TabsProps, START_INDEX } from './types';
import Button from '@/components/Button/BaseButton';
import clsx from 'clsx';
import EditButton from '@/components/Button/EditButton';

import styles from './Tabs.module.css';

const Tabs = ({ tabsData, tabsDesctiptionClassName, activeIndex = 0 }: TabsProps) => {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(activeIndex);
  return (
    <div className={styles.tabs}>
      <div className={styles.tabsTitle}>
        {tabsData.map((tab, idx) => {
          return (
            <Button
              id={`tab-${idx}`}
              data-testid={`tab-${idx}`}
              key={`tab-${tab.name}`}
              classes={clsx(styles.tab, {
                [styles.activeTab]: idx === activeTabIndex,
              })}
              onClick={() => setActiveTabIndex(idx)}
            >
              <span className={styles.tabLabel}>{tab.name}</span>
              <span className={clsx(styles.endIconButton, { [styles.activeTab]: idx === activeTabIndex })} />
              <EditButton
                id={`tab-edit-${START_INDEX + idx}`}
                recordId={`${START_INDEX + idx}`}
                slug="promoAlertMessageEdit"
                className={styles.editIcon}
              />
            </Button>
          );
        })}
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: tabsData[activeTabIndex]?.description }}
        className={clsx(styles.tabDescription, tabsDesctiptionClassName)}
      />
    </div>
  );
};

export default Tabs;
